export default function Expertise() {
  const areas = [
    {
      icon: "ri-smartphone-line",
      title: "iOS Platform Engineering",
      description:
        "Deep expertise in native engineering for mobile platforms, with emphasis on seamless system integration, platform-specific optimization, and adherence to established platform conventions that ensure a cohesive and intuitive user experience.",
    },
    {
      icon: "ri-stack-line",
      title: "System Architecture",
      description:
        "Clean architectural patterns that ensure scalability, maintainability, and long-term adaptability of complex codebases. We design systems with separation of concerns, modularity, and testability as foundational principles.",
    },
    {
      icon: "ri-speed-up-line",
      title: "Performance Optimization",
      description:
        "High-performance system design focused on stability, efficiency, and seamless user experiences under varying loads. We apply profiling, instrumentation, and targeted refinement to eliminate bottlenecks and improve responsiveness.",
    },
  ];

  return (
    <section className="w-full py-16 md:py-24 lg:py-32 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <p className="text-xs md:text-sm tracking-wider uppercase text-secondary-600 font-medium mb-3 md:mb-4">
          Expertise
        </p>
        <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-10 md:mb-16">
          Platform
          <br />
          Engineering
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-8">
          {areas.map((area) => (
            <div
              key={area.title}
              className="bg-background-100 rounded-lg p-6 md:p-8"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center mb-5 md:mb-6">
                <i className={`${area.icon} text-2xl md:text-3xl text-primary-600`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-3 md:mb-4">
                {area.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                {area.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}